import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=26a559a8&scoped=true&"
import script from "./SocialLogin.vue?vue&type=script&async=true&lang=js&"
export * from "./SocialLogin.vue?vue&type=script&async=true&lang=js&"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=26a559a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a559a8",
  null
  
)

export default component.exports